import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function ImagineSection() {
  return <SectionWrapper narrow data-id="element-90">
      <div className="flex flex-col items-center text-center space-y-12 md:space-y-16 py-10" data-id="element-91">
        <p className="text-2xl md:text-3xl font-serif text-text leading-relaxed" data-id="element-92">
          Imaginá terminar una discusión y recuperar tu eje en minutos.
        </p>
        <p className="text-2xl md:text-3xl font-serif text-text leading-relaxed" data-id="element-93">
          Imaginá no llevarte el día a la cama.
        </p>
        <p className="text-2xl md:text-3xl font-serif text-text leading-relaxed" data-id="element-94">
          Imaginá elegir en lugar de reaccionar.
        </p>
      </div>
    </SectionWrapper>;
}